import { ElMessage } from "element-plus";
import { ElNotification } from "element-plus";

export default {
  // 消息提示
  msg(msg, type, html) {
    //warning error
    ElMessage({
      message: msg,
      type: type ? type : "",
      //   plain: true,
      dangerouslyUseHTMLString: html ? html : false,
    });
  },
  notic(msg, type) {
    //warning success info error
    ElNotification({
      title: "提示",
      message: msg,
      type: type?type:'',
      duration:2500
    });
  },
};
